const shop = [
  {
    key: "selected",
    label: "เลือกรายการ",
    class: "text-center",
  },
  {
    key: "id",
    label: "เลขที่ใบเสร็จ",
    sortable: true,
  },
  {
    key: "shop_code",
    label: "รหัสร้าน",
    sortable: true,
  },
  {
    key: "shop_name",
    label: "ชื่อร้าน",
    sortable: true,
  },
  {
    key: "customer_type",
    label: "ประเภทร้าน",
    sortable: true,
  },
  {
    key: "status",
    label: "สถานะ",
    sortable: true,
  },
  {
    key: "total_item",
    label: "จำนวนพัสดุ",
    sortable: true,
  },
  {
    key: "amount",
    label: "ยอดรวม COD",
    sortable: true,
  },
  {
    key: "vat",
    label: "ภาษีมูลค่าเพิ่ม",
    sortable: true,
  },
  {
    key: "withholding_tax",
    label: "หักภาษี ณ ที่จ่าย",
    sortable: true,
  },
  {
    key: "net",
    label: "Commission สุทธิ",
    sortable: true,
  },
  {
    key: "bank_name",
    label: "ธนาคาร",
    field: "bank_name",
  },
  {
    key: "created_at",
    label: "วันที่สร้างบิล",
    sortable: true,
  },
];

const superAdmin = [
  {
    key: "selected",
    label: "เลือกรายการ",
    class: "text-center",
  },
  {
    key: "dealer_id",
    label: "รหัสตัวแทน",
    sortable: true,
  },
  {
    key: "shop_name",
    label: "ชื่อตัวแทน",
    sortable: true,
  },
  {
    key: "customer_type",
    label: "ประเภทร้าน",
    sortable: true,
  },
  {
    key: "status",
    label: "สถานะ",
    sortable: true,
  },
  {
    key: "total_item",
    label: "จำนวนพัสดุ",
    sortable: true,
  },
  {
    key: "amount",
    label: "ยอดรวม COD",
    sortable: true,
  },
  {
    key: "vat",
    label: "ภาษีมูลค่าเพิ่ม",
    sortable: true,
  },
  {
    key: "withholding_tax",
    label: "หักภาษี ณ ที่จ่าย",
    sortable: true,
  },
  {
    key: "bank_name",
    label: "ธนาคาร",
    field: "bank_name",
  },
  {
    key: "net",
    label: "Commission สุทธิ",
    sortable: true,
  },
  {
    key: "created_at",
    label: "วันที่สร้างบิล",
    sortable: true,
  },
];

const shopExport = [
  {
    label: "*Receiving Bank",
    field: "bank_name",
  },
  {
    label: "*Receiving Branch Code = 4",
    field: "bank_branch",
    branchFormat: (value) => {
      const fillZero = (branch) => {
        if (branch.length < 4) {
          branch = "0" + branch;
          fillZero(branch);
        } else {
          return branch;
        }
      };
      fillZero(value);
    },
  },
  {
    label: "*Credit Account <= 25",
    field: "bank_account",
  },
  {
    label: "*PromptPay Proxy type",
    field: "",
  },
  {
    label: "*PromptPay Proxy ID <= 100",
    field: "",
  },
  {
    label: "*Beneficiary Name 1 (TH/EN)  <= 140",
    field: "account_name",
  },
  {
    label: "*Credit Amount",
    field: "net",
  },
  {
    label: "*Beneficiary Charge",
    field: "charge",
    returnValue: () => {
      return "Sender charge";
    },
  },
  {
    label: "*WHT* Beneficiary IDCard/TaxID <= 15",
    field: "",
  },
  {
    label: "*Bahtnet* Beneficiary Name (English) <= 140",
    field: "",
  },
  {
    label: "Beneficiary Mobile Phone Number1 <= 15",
    field: "tel",
  },
  {
    label: "Beneficiary Mobile Phone Number2 <= 15",
    field: "",
  },
  {
    label: "Beneficiary Mobile Phone Number3 <= 15",
    field: "",
  },
  {
    label: 'Beneficiary E-mail Address (separator ";" or ",") <= 100',
    field: "email",
  },
  {
    label: "Beneficiary Fax Number <= 15",
    field: "",
  },
  {
    label: "*Bahtnet/WHT* Beneficiary Address 1 <= 70",
    field: "",
  },
  {
    label: "Beneficiary Address 2 <= 70",
    field: "",
  },
  {
    label: "Beneficiary Address 3 <= 70",
    field: "",
  },
  {
    label: "Remark 1 <= 100",
    field: "remark",
    remarkFormat: () => {
      return "โอนเงินค่าคอมมิชชั่น 20";
    },
  },
  {
    label: "Remark 2 <= 100",
    field: "remark",
    remarkFormat: () => {
      return "โอนเงินค่าคอมมิชชั่น 20";
    },
  },
  {
    label: "Customer reference <= 20",
    field: "shop_code",
  },
  {
    label: "Customer type",
    field: "customer_type",
  }
];
const shopExportNew = [
  {
    label: "*Receiving Bank",
    field: "bank_name",
  },
  {
    label: "*Receiving Branch Code = 4",
    field: "bank_branch",
    branchFormat: (value) => {
      const fillZero = (branch) => {
        if (branch.length < 4) {
          branch = "0" + branch;
          fillZero(branch);
        } else {
          return branch;
        }
      };
      fillZero(value);
    },
  },
  {
    label: "*Credit Account <= 25",
    field: "bank_account",
  },
  {
    label: "*PromptPay Proxy type",
    field: "",
  },
  {
    label: "*PromptPay Proxy ID <= 100",
    field: "",
  },
  {
    label: "*Beneficiary Name 1 (TH/EN)  <= 140",
    field: "account_name",
  },
  {
    label: "*Credit Amount",
    field: "net",
  },
  {
    label: "*Beneficiary Charge",
    field: "charge",
    returnValue: () => {
      return "Sender charge";
    },
  },
  {
    label: "*WHT* Beneficiary IDCard/TaxID <= 15",
    field: "",
  },
  {
    label: "*Bahtnet* Beneficiary Name (English) <= 140",
    field: "",
  },
  {
    label: "Beneficiary Mobile Phone Number1 <= 15",
    field: "tel",
  },
  {
    label: "Beneficiary Mobile Phone Number2 <= 15",
    field: "",
  },
  {
    label: "Beneficiary Mobile Phone Number3 <= 15",
    field: "",
  },
  {
    label: 'Beneficiary E-mail Address (separator ";" or ",") <= 100',
    field: "email",
  },
  {
    label: "Beneficiary Fax Number <= 15",
    field: "",
  },
  {
    label: "*Bahtnet/WHT* Beneficiary Address 1 <= 70",
    field: "",
  },
  {
    label: "Beneficiary Address 2 <= 70",
    field: "",
  },
  {
    label: "Beneficiary Address 3 <= 70",
    field: "",
  },
  {
    label: "Remark 1 <= 100",
    field: "remark",
    remarkFormat: () => {
      return "โอนเงินค่าคอมมิชชั่น 20";
    },
  },
  {
    label: "Remark 2 <= 100",
    field: "remark",
    remarkFormat: () => {
      return "โอนเงินค่าคอมมิชชั่น 20";
    },
  },
  {
    label: "Customer reference <= 20",
    field: "shop_code",
  },
  {
    label: "Customer type",
    field: "customer_type",
  }
];
const superAdminExport = [
  {
    label: "*Receiving Bank",
    field: "bank_name",
  },
  {
    label: "*Receiving Branch Code = 4",
    field: "bank_branch",
    branchFormat: (value) => {
      const fillZero = (branch) => {
        if (branch.length < 4) {
          branch = "0" + branch;
          fillZero(branch);
        } else {
          return branch;
        }
      };
      fillZero(value);
    },
  },
  {
    label: "*Credit Account <= 25",
    field: "bank_account",
  },
  {
    label: "*PromptPay Proxy type",
    field: "",
  },
  {
    label: "*PromptPay Proxy ID <= 100",
    field: "",
  },
  {
    label: "*Beneficiary Name 1 (TH/EN)  <= 140",
    field: "account_name",
  },
  {
    label: "*Credit Amount",
    field: "net",
  },
  {
    label: "*Beneficiary Charge",
    field: "charge",
    returnValue: () => {
      return "Sender charge";
    },
  },
  {
    label: "*WHT* Beneficiary IDCard/TaxID <= 15",
    field: "",
  },
  {
    label: "*Bahtnet* Beneficiary Name (English) <= 140",
    field: "",
  },
  {
    label: "Beneficiary Mobile Phone Number1 <= 15",
    field: "tel",
  },
  {
    label: "Beneficiary Mobile Phone Number2 <= 15",
    field: "",
  },
  {
    label: "Beneficiary Mobile Phone Number3 <= 15",
    field: "",
  },
  {
    label: 'Beneficiary E-mail Address (separator ";" or ",") <= 100',
    field: "email",
  },
  {
    label: "Beneficiary Fax Number <= 15",
    field: "",
  },
  {
    label: "*Bahtnet/WHT* Beneficiary Address 1 <= 70",
    field: "",
  },
  {
    label: "Beneficiary Address 2 <= 70",
    field: "",
  },
  {
    label: "Beneficiary Address 3 <= 70",
    field: "",
  },
  {
    label: "Remark 1 <= 100",
    field: "remark",
  },
  {
    label: "Remark 2 <= 100",
    field: "",
    // field: 'remark2'
  },
  {
    label: "Customer reference <= 20",
    field: "dealer_id",
  },
  {
    label: "Customer type",
    field: "customer_type",
  }
];

export default {
  shop,
  superAdmin,
  shopExport,
  shopExportNew, // for test hotfix
  superAdminExport,
};
